import { useQuery } from '@apollo/client'
import { studentPrivacyQuery } from '../../../appsync/graphql/student'
import { formatAppsyncErrors } from '../../../appsync/utils'

const useStudentPrivacyQuery = ({ orgId, countryCd, otherSkipConditions = false }) => {
  const {
    loading,
    error: rawError = null,
    data: rawData = {},
  } = useQuery(studentPrivacyQuery, {
    variables: { orgId, countryCd }, // countryCd is only used to make unique requests per countryCd
    skip: !orgId || !countryCd || otherSkipConditions,
  })
  const data = rawData?.getStudentPrivacyRestrictions ?? {}
  const error = rawError ? formatAppsyncErrors(rawError) : null

  return { data, loading, error }
}

export default useStudentPrivacyQuery
